/**
 * @file environment.ts
 * @description Defines environment-specific configuration for the Angular application.
 */

/**
 * Indicates whether the build is for production.
 * @type {boolean}
 */
export const environment = {
  /** 
   * Flag to enable production mode optimizations.
   * Set to `true` when deploying to production.
   */
  production: false,

  /**
   * Base URL for API requests.
   * Replace with your actual backend endpoint in production.
   * Example: 'https://api.example.com/v1'
   */
 
  API_ENDPOINT: 'http://ubuntu@ec2-13-60-61-78.eu-north-1.compute.amazonaws.com:3000/api',
  STRIPE_KEY: 'pk_test_51Rw3FKH17peLWxSoQwJz5yFaCH5pCyf15u3kAV2GxzfK8NUdx2CL15nUpn5rjuP5LALP6KPwS4jXPiCQ3BKVBpSP007Dt8DZRO'
};
 